import { useProjectActions, useProjectContext } from "@contexts/projects";
import { formatNumberToCurrency } from "@utils/formatNumber";
import MoneyInput from "@utils/moneyInput";
import { useEffect, useState } from "react";
import { extraValueActiveMutation, extraValueAppendMutation } from "../extraValues/ExtraValueAccordion";

const TableMonthExtraValues = () => {
  const { selectedDetail: { item }, activeProject, projectionTable, tableMonthSelected } = useProjectContext();
  const { getExtraValues, getWbsPath, updateExtra } = useProjectActions();
  const [toggle, setToggle] = useState(false)
  const [newValue, setNewValue] = useState({
    value: '0',
    description: '',
    month: new Date().toISOString().slice(0, 7),
    installments: '',
  })
  const [extraValueInfos, setExtraValeInfos] = useState({
    path: [],
    values: [],
    extraValues: []
  })

  useEffect(() => {
    if (projectionTable && window.location.pathname.includes('projecao-financeira')) {
      getExtraValuesInfo()
    }
  }, [item, tableMonthSelected])

  const getExtraValuesInfo = async () => {
    const extraValues = await getExtraValues(activeProject.building_id, item.wbs_code_id)
    const id = activeProject.wbs_code_ids.filter(i => item.wbs_code_id.includes(i))[0]
    const wbs = item.wbs_code_id.replace(id, '')
    const res = await getWbsPath(wbs, id)
    setExtraValeInfos({
      path: res.response,
      values: res.values,
      extraValues: Array.isArray(extraValues?.response) ? extraValues.response : []
    })
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setNewValue((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  }

  const handleValueChange = (e) => {
    setNewValue((prevValue) => ({
      ...prevValue,
      value: e,
    }));
  };

  const checkName = () => {
    if (item.description) return item.description
    if (item.building_unit_name) return item.building_unit_name
    if (item.name) return item.name
  }

  const handleSend = async () => {

    const firstMonth = newValue.month;
    const installments = parseInt(newValue.installments, 10) || 1;

    const [yearStr, monthStr] = String(firstMonth).split("-");
    const startYear = parseInt(yearStr, 10);
    const startMonth = parseInt(monthStr, 10);

    const totalMonths = startYear * 12 + (startMonth - 1) + (installments - 1);
    const lastYear = Math.floor(totalMonths / 12);
    const lastMonthNum = (totalMonths % 12) + 1;

    const pad = (n) => String(n).padStart(2, "0");
    const lastMonth = `${lastYear}-${pad(lastMonthNum)}`;


    const response = await updateExtra(item.wbs_code_id, extraValueAppendMutation({
      value: Number(newValue.value),
      installments,
      start_date: firstMonth,
      end_date: lastMonth,
      isValid: true,
      description: newValue.description,
    }), checkName())
    if (response?.code === 200 && response.document) {
      setExtraValeInfos(prev => ({
        ...prev,
        extraValues: prev.extraValues.some(resource => (
          resource._id === response.document._id
          || resource.wbs_code_id === response.document.wbs_code_id
        ))
          ? prev.extraValues.map(resource => (
            resource._id === response.document._id
            || resource.wbs_code_id === response.document.wbs_code_id
              ? response.document
              : resource
          ))
          : [...prev.extraValues, response.document],
      }))
    }

  }

  const handleDelete = async (resource, entry, entryIndex) => {
    const response = await updateExtra(
      resource.wbs_code_id,
      extraValueActiveMutation(entry, resource.history, entryIndex),
      resource.item_name,
    )
    if (response?.code === 200 && response.document) {
      setExtraValeInfos(prev => ({
        ...prev,
        extraValues: prev.extraValues.map(candidate => (
          candidate._id === response.document._id
          || candidate.wbs_code_id === response.document.wbs_code_id
            ? response.document
            : candidate
        )),
      }))
    }
  };

  return <>
    <div className="margin-bottom-8 flex align-center">
      <button
        className={`accordion-toggle ${toggle ? "active" : ""}`}
        onClick={() => setToggle(!toggle)}
      />
      <span style={{ fontWeight: "bold", fontSize: '22px' }}>Estouros / Economias</span>
    </div>
    {/* <div className="columns-4-laptop gap-4 grid">
      <Card label="Orçado" content={formatNumberToCurrency(extraValueInfos.values?.budget?.value)} />
      <Card label="Orçado Indexado" content={formatNumberToCurrency(extraValueInfos.values?.budget?.indexed_value)} />
      <Card label="Previsto" content={formatNumberToCurrency(extraValueInfos.values?.predicted?.value)} />
      <Card label="Comprometido" content={formatNumberToCurrency(extraValueInfos.values?.commited?.value)} />
    </div> */}
    {toggle && <>
      {extraValueInfos.extraValues.length > 0 && extraValueInfos.extraValues.flatMap(resource => (
        (resource.history || []).map((entry, entryIndex) => <div key={entry.entryId || `${resource.wbs_code_id}-${entry.start_date}-${entry.value}-${entry.description || ''}-${entry.updated_at || ''}`} className="accordion-item">
          <div className="accordion-item-body" style={{ gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', gap: '16px' }}>
            <div className="margin-right-16">
              <span className="accordion-label">Valor</span>
              <span className="accordion-title">{formatNumberToCurrency(entry.value)}</span>
            </div>
            <div className="margin-right-16">
              <span className="accordion-label">Data</span>
              <span className="accordion-title">{`${entry?.installments > 1 ? `${entry?.start_date.split('-').reverse().join('/')} - ${entry?.end_date.split('-').reverse().join('/')}` : entry?.start_date}`}</span>
            </div>
            <div className="margin-right-16">
              <span className="accordion-label">Parcelas</span>
              <span className="accordion-title">{`${entry?.installments} (${formatNumberToCurrency(entry?.value / entry?.installments)})`}</span>
            </div>
            <div className="margin-right-16">
              <span className="accordion-label">Descrição</span>
              <span className="accordion-title">{entry.description}</span>
            </div>
            <button style={{ justifySelf: 'end' }} className={`button button-${entry.isValid ? 'error' : 'green'} small`} onClick={() => handleDelete(resource, entry, entryIndex)}>{entry.isValid ? 'Desativar' : 'Ativar'}</button>

          </div>
        </div>
        ))
      )}
      <div className="flex gap-16 align-center margin-top-8 margin-bottom-8 offcanvas-extra-value">
        <MoneyInput value={newValue.value} onChange={handleValueChange} />
        <input
          className="resource-search"
          type="month"
          name="month"
          value={newValue.month}
          onChange={handleChange}
          placeholder="Data"
        />
        <input
          className="resource-search"
          type="text"
          name="description"
          value={newValue.description}
          onChange={handleChange}
          placeholder="Descrição"
        />
        <select onChange={handleChange} name="installments" defaultValue={''} value={newValue.installments}>
          <option value={''} disabled>Parcelas</option>
          {Array.from({ length: 36 }, (_, i) => i + 1).map(num => (
            <option key={num} value={num}>{num} ({formatNumberToCurrency(newValue.value / num)})</option>
          ))}
        </select>
        <button onClick={handleSend} className="button button-accent small">Enviar</button>
      </div>
    </>}
  </>
}

export default TableMonthExtraValues;
